import { createFeature, createReducer, on } from '@ngrx/store';
import { initialTourManagerState, TourManagerState } from '../states/tour-manager.state';
import { TourManagerActions } from '../actions/tour-manager.actions';

export const tourManagerFeature = createFeature({
  name: 'tourManager',
  reducer: createReducer<TourManagerState>(
    initialTourManagerState,

    on(TourManagerActions.setTourStart, (state, { tourStart }) => ({
      ...state,
      tourStart,
    }))
  ),
});

export const {
  name: tourManagerFeatureKey,
  reducer: tourManagerReducer,
  selectTourStart,
} = tourManagerFeature;